"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LangInfo = void 0;
var LangInfo = (function () {
    function LangInfo(bidi, eastAsia, latin) {
        this.bidi = bidi || "";
        this.eastAsia = eastAsia || "";
        this.latin = latin || "";
    }
    LangInfo.prototype.copyFrom = function (obj) {
        this.bidi = obj.bidi;
        this.eastAsia = obj.eastAsia;
        this.latin = obj.latin;
    };
    LangInfo.prototype.equals = function (obj) {
        return obj && this.bidi == obj.bidi &&
            this.eastAsia == obj.eastAsia &&
            this.latin == obj.latin;
    };
    LangInfo.equalsBinary = function (langInfoA, langInfoB) {
        return langInfoA && langInfoB &&
            langInfoA.bidi == langInfoB.bidi &&
            langInfoA.eastAsia == langInfoB.eastAsia &&
            langInfoA.latin == langInfoB.latin;
    };
    LangInfo.prototype.clone = function () {
        var obj = new LangInfo(null, null, null);
        obj.copyFrom(this);
        return obj;
    };
    LangInfo.prototype.isEmpty = function () {
        if (this.bidi == "" && this.eastAsia == "" && this.latin == "")
            return true;
        return false;
    };
    return LangInfo;
}());
exports.LangInfo = LangInfo;
